class AddToBoxButton extends HTMLElement {
  static addedProductsList = [];

  constructor() {
    super();
    this.addEventListener("click", this.toggleProduct);
  }

  connectedCallback(){
    this.minProducts = parseInt(document.querySelector("new-build-a-box").dataset.minProducts);
    this.updateButtonState();
  }

  toggleProduct = () => {
    const variantId = this.getAttribute("data-variant-id");
    const productTitle = this.getAttribute("data-product-title");
    const variantImage = this.getAttribute("data-product-image");
    const productPrice = this.getAttribute("data-product-price")/100;
    const productSku = this.getAttribute("data-product-sku");
    const maxProducts = parseInt(this.dataset.maxProducts);

    const addedProducts = AddToBoxButton.addedProductsList;

    const index = addedProducts.findIndex((p) => p.variant_id === variantId);

    if (index > -1) {
      addedProducts.splice(index, 1);
    } else if (addedProducts.length < maxProducts) {
      addedProducts.push({ product_title:productTitle, product_price: productPrice, variant_id: variantId, variant_image: variantImage, quantity: 1, product_sku: productSku });

      const clevertapData = {
        Product_Name: productTitle,
        Qty: 1,
        Price: productPrice,
        SKU: productSku
      }

      dataLayer.push({
        event: "Add_To_Bundle",
        Product_Name: productTitle,
        Qty: 1,
        Price: productPrice,
        SKU: productSku,
        clevertap: clevertapData
      });

      if (addedProducts.length >= this.minProducts) {
        shootConfetti();
      }
    }

    const buildABox = document.querySelector('new-build-a-box');
    this.updateButtonState();
    buildABox.updateBottomNav();
  };

  updateButtonState() {
    const addedProducts = AddToBoxButton.addedProductsList;;
    const variantId = this.getAttribute("data-variant-id");
    const isAdded = addedProducts.some((p) => p.variant_id === variantId);

    this.textContent = isAdded ? "Remove item" : "Add to box";
    this.classList.toggle("disabled", !isAdded && addedProducts.length >= parseInt(this.dataset.maxProducts));
  }
}

customElements.define("add-to-box-button", AddToBoxButton);

class NewBuildABox extends HTMLElement {
  constructor(){
    super();
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.showCart = true;
    this.boxProductsList = [...this.querySelectorAll(".byob__product-wrapper")];
    this.removeButtonsList = [...this.querySelectorAll(".byob__remove-button")];
    this.productPriceEl = this.querySelector(".byob__products-mrp");
    this.savedStripEl = this.querySelector(".byob__saved-price");
    this.bundleValue = this.querySelector(".byob__bundle-value");
    this.addToCartButton = this.querySelector(".byob__add-to-cart-button");
    this.offerTabs = [...document.querySelectorAll(".offer-item")];
    this.progressBarFill = this.querySelector(".byob__progress-bar-box-fill");
    this.milestoneText = this.querySelector(".byob__milestone-progress-text");
    this.collectionId = this.addToCartButton.dataset.collectionId;
    this.milestoneText = this.querySelector(".byob__milestone-text");
  }

  connectedCallback() {
    this.removeButtonsList.forEach((button, index) => {
      button.addEventListener("click", () => this.removeProduct(index));
    });
  
    this.offerTabs.forEach((eachTab, index) => {
      eachTab.addEventListener("click", (event) => this.onChangeBundleOffer(event, index));
    });
  
    this.productsArray = this.dataset.productsArray.split(",").map((bundleCount) => parseInt(bundleCount));
    this.valuesArray = this.dataset.valuesArray.split(",").map((bundleValue) => parseInt(bundleValue));
    this.currentOfferIndex = 0;
    this.isOfferSelected = false;
    this.offerValue = this.valuesArray[0];

    this.addToCartButton.addEventListener("click", () => {
      this.addBoxProductsToCart();
    });

    this.updateBottomNav();
  }

  addBoxProductsToCart() {
    const addedProducts = AddToBoxButton.addedProductsList;
    const titlesArray = [];
    const skuArray = []
    addedProducts.forEach((eachProduct) => {
      titlesArray.push(eachProduct.product_title);
      skuArray.push(eachProduct.product_sku);
    })

    const productsIndex = this.productsArray.findIndex((productCount) => productCount === addedProducts.length);
    const offerValue = this.valuesArray[productsIndex];

    const uniqueRandomPropertyname = `${this.collectionId}__buy${addedProducts.length}`;
    const uniqueRandomProperty = { addictedToGoodBox: uniqueRandomPropertyname, productType: "BYOB" };
    const items = addedProducts.map(({ variant_id, quantity }) => ({ id: variant_id, quantity, properties: uniqueRandomProperty }));
    const payload = { items };

    if (this.cart) {
      payload.sections = this.cart.getSectionsToRender().map(({ id }) => id);
      payload.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    fetch("/cart/add.js", {
      ...fetchConfig("javascript"),
      body: JSON.stringify(payload),
    })
    .then((res) => res.json())
    .then((data) => {
      this.cart.renderContents(data, this.showCart);
      this.cart.addFreebie();
      this.cart.open();

      const clevertapData = {
        Product_names: titlesArray.join(", "),
        qty: addedProducts.length,
        total_price: offerValue,
        SKU: skuArray.join(", ")
      }

      dataLayer.push({
        event: "Build_Your_Box",
        Product_names: titlesArray.join(", "),
        qty: addedProducts.length,
        total_price: offerValue,
        SKU: skuArray.join(", "),
        clevertap: clevertapData
      });

      this.clearBox();
    })
    .catch(console.error)
    .finally(() => {
      this.cart?.classList.remove("is-empty");
    });
  }

  clearBox() {
    AddToBoxButton.addedProductsList = [];
    this.updateBottomNav();
  }
  
  onChangeBundleOffer = (event, index) => {
    this.currentOfferIndex = index;
    this.isOfferSelected = true;

    const clevertapData = {
      Type_Value: event.target.dataset.offer
    }

    dataLayer.push({
      event: "Bundle_Type",
      Type_Value: event.target.dataset.offer,
      clevertap: clevertapData
    });

    if (AddToBoxButton.addedProductsList.length > this.productsArray[index]) {
      AddToBoxButton.addedProductsList.splice(this.productsArray[index])
    }

    this.offerTabs.forEach((eachTab) => eachTab.classList.remove('active'));
    event.target.classList.add('active');
    
    this.milestoneText.textContent = `Add ${this.productsArray[index]} products to get ${this.productsArray[index]}@${this.valuesArray[index]}`;
    this.bundleValue.textContent = `Total: Rs. ${this.valuesArray[index]}`

    const bundleCount = parseInt(event.target.dataset.productCount);
    this.boxProductsList.forEach((eachBox, index) => {
      if (index <= bundleCount - 1) {
        eachBox.classList.remove('hide-element');
      }
      else{
        eachBox.classList.add('hide-element');
      }
    })

    this.updateBottomNav();
  };

  removeProduct(index) {
    if (index > -1 && index < AddToBoxButton.addedProductsList.length) {
      AddToBoxButton.addedProductsList.splice(index, 1);
      this.updateBottomNav();
    }
  }

  updateBottomNav(){
    const addedProducts = AddToBoxButton.addedProductsList;
    this.offerTabs.forEach((eachTab) => eachTab.classList.remove('active'));
    this.offerTabs[this.currentOfferIndex].classList.add('active');
    let productsPrice = 0;
    this.boxProductsList.forEach((box, index) => {
      const product = addedProducts[index];
      const img = box.querySelector("img");
      if (product) {
        img.src = product.variant_image;
        productsPrice += parseInt(product.product_price);
        box.classList.add("box__milestone-reached");

        if (this.boxProductsList[index+1] && addedProducts.length >= this.productsArray[this.currentOfferIndex]) {
          this.boxProductsList[index+1].classList.remove('hide-element');
        }
      } else {
        img.removeAttribute("src");
        box.classList.remove("box__milestone-reached");
        
        if (this.boxProductsList[index+1] && addedProducts.length >= this.productsArray[this.currentOfferIndex] - 1) {
          this.boxProductsList[index+1].classList.add('hide-element');
        }
      }
    });

    if (this.progressBarFill) {
      const activeBoxesLength = this.boxProductsList.length - (this.querySelectorAll(".byob__product-wrapper.hide-element").length);
      const filledPercentage = (addedProducts.length / activeBoxesLength) * 100;
      this.progressBarFill.style.width = `${filledPercentage}%`;
      this.addToCartButton.classList.toggle("disabled", filledPercentage < 100);
    }

    let offerIndex = 0
    if (this.productsArray[0] <= addedProducts.length ) {
      offerIndex = this.productsArray.findIndex(productCount => productCount === addedProducts.length);
      this.offerTabs[0].classList.remove('active'); 
      if (this.offerTabs[offerIndex + 1]) {
        if (this.isOfferSelected) {
          if(offerIndex + 1 >= this.currentOfferIndex) {
            this.offerTabs.forEach((eachTab) => eachTab.classList.remove('active'));
            this.offerTabs[offerIndex + 1].classList.add('active');
          }
        }else {
          this.offerTabs[offerIndex + 1].classList.add('active');
        }
      }
      else {
        if (this.isOfferSelected) {
          if(offerIndex >= this.currentOfferIndex){
            this.offerTabs.forEach((eachTab) => eachTab.classList.remove('active'));
            this.offerTabs[offerIndex].classList.add('active');
          }
        }else {
          this.offerTabs[offerIndex].classList.add('active');
        }
      }
      
      if (offerIndex > -1) {
        const bundleValue = this.valuesArray[offerIndex];

        this.querySelector(".byob__add-to-cart-price").textContent = `Rs. ${bundleValue}`;
        this.bundleValue.textContent = `Total: Rs.${bundleValue}`;
        this.productPriceEl.classList.remove('hide-element');
        this.savedStripEl.classList.remove('hide-element');
        this.productPriceEl.textContent = `MRP: Rs.${productsPrice}`;
        this.addToCartButton.dataset.bundleValue = bundleValue;
        this.savedStripEl.textContent = `Save: Rs.${productsPrice - bundleValue}`;
        this.addToCartButton.classList.remove('disabled');
      }
    }
    else{
      this.productPriceEl.classList.add('hide-element');
      this.savedStripEl.classList.add('hide-element');
      this.addToCartButton.classList.add('disabled');
    }

    if (offerIndex > -1) {
      const nextThreshold = this.productsArray[offerIndex >= this.currentOfferIndex ? offerIndex : this.currentOfferIndex];
      const nextValue = this.valuesArray[offerIndex >= this.currentOfferIndex ? offerIndex : this.currentOfferIndex];
      const remaining = nextThreshold - addedProducts.length;
  
      if (remaining > 0) {
        if (remaining === this.productsArray[this.currentOfferIndex]) {
          this.milestoneText.textContent = `Add ${remaining} products to get ${nextThreshold} @ Rs.${nextValue}`;
        }
        else{
          this.milestoneText.textContent = `Add ${remaining} more product${remaining > 1 ? "s" : ""} to get ${nextThreshold} @ Rs.${nextValue}`;
        }
      } else {
        this.milestoneText.textContent = `Bundle unlocked! ${nextThreshold} @ Rs.${nextValue}`;
      }
    }

    document.querySelectorAll("add-to-box-button").forEach((button) => this.updateButtonState(button));
  };

  updateButtonState(button) {
    const addedProducts = AddToBoxButton.addedProductsList;
    const variantId = button.getAttribute("data-variant-id");
    const isAdded = addedProducts.some((product) => product.variant_id === variantId);

    button.textContent = isAdded ? "Remove item" : "Add to box";
    button.classList.toggle("disabled", !isAdded && addedProducts.length >= parseInt(button.dataset.maxProducts));
  }
}

customElements.define('new-build-a-box', NewBuildABox);

// Custom confetti shooter
function shootConfetti() {
  const canvas = document.createElement("canvas");
  document.body.appendChild(canvas);
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  canvas.style.position = "fixed";
  canvas.style.top = "0";
  canvas.style.left = "0";
  canvas.style.pointerEvents = "none";
  canvas.style.zIndex = "9999";
  canvas.style.transition = "opacity 1s ease-out";

  const ctx = canvas.getContext("2d");
  const confettiParticles = [];

  class Confetti {
    constructor() {
      this.x = window.innerWidth / 2;
      this.y = window.innerHeight / 2;
      this.size = Math.random() * 8 + 3;
      this.shape = Math.floor(Math.random() * 3);
      this.color = `hsl(${Math.random() * 360}, 100%, 70%)`;
      this.speedX = (Math.random() - 0.5) * 10;
      this.speedY = (Math.random() - 0.5) * 10;
      this.rotation = Math.random() * 360;
      this.rotationSpeed = Math.random() * 6 - 3;
      this.opacity = 1;
      this.waveAngle = Math.random() * Math.PI * 2;
    }

    update() {
      this.waveAngle += 0.1;
      this.x += this.speedX + Math.sin(this.waveAngle) * 2;
      this.y += this.speedY + Math.cos(this.waveAngle) * 2;
      this.rotation += this.rotationSpeed;

      this.speedY += 0.1;
      this.opacity -= 0.01;

      if (this.opacity <= 0) {
        this.opacity = 0;
      }
    }

    draw() {
      ctx.save();
      ctx.globalAlpha = this.opacity;
      ctx.translate(this.x, this.y);
      ctx.rotate((this.rotation * Math.PI) / 180);
      ctx.fillStyle = this.color;

      if (this.shape === 0) {
        ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size);
      } else if (this.shape === 1) {
        ctx.beginPath();
        ctx.arc(0, 0, this.size / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.beginPath();
        ctx.moveTo(0, -this.size / 2);
        ctx.lineTo(-this.size / 2, this.size / 2);
        ctx.lineTo(this.size / 2, this.size / 2);
        ctx.closePath();
        ctx.fill();
      }

      ctx.restore();
    }
  }

  function createConfetti() {
    for (let i = 0; i < 150; i++) {
      confettiParticles.push(new Confetti());
    }
  }

  function animateConfetti() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    confettiParticles.forEach((particle) => {
      particle.update();
      particle.draw();
    });

    if (confettiParticles.some(p => p.opacity > 0)) {
      animationId = requestAnimationFrame(animateConfetti);
    } else {
      fadeOutCanvas();
    }
  }

  function fadeOutCanvas() {
    canvas.style.opacity = "0";
    setTimeout(() => {
      document.body.removeChild(canvas);
    }, 1000);
  }

  createConfetti();
  let animationId = requestAnimationFrame(animateConfetti);
}


function updateOffersWrapper() {
  const header = document.querySelector(".shopify-section-header-sticky.scrolled-past-header");
  const offersWrapper = document.querySelector(".offers__wrapper");

  if (header && offersWrapper) {
    offersWrapper.classList.add("sticky-active");
  } else if (offersWrapper) {
    offersWrapper.classList.remove("sticky-active");
  }
}

updateOffersWrapper();

const observer = new MutationObserver(updateOffersWrapper);
const headerElement = document.querySelector(".shopify-section-header-sticky");

if (headerElement) {
  observer.observe(headerElement, { attributes: true, attributeFilter: ["class"] });
}